import $ from 'jquery'
import jQuery from 'jquery'
import 'slick-carousel'
import { getHTMLData, hasValue } from './../lib/lib'
import HeroNavCarousel from './w-hero-nav'

class HeroCarousel {
  constructor(element) {
    if (!element) return

    this.elem = jQuery(element)

    this._iniVars()

    this.autoplaySpeed = getHTMLData(this.elem, 'autoplay-speed', 4000)

    this.nav = new HeroNavCarousel({
      element: this.elem.find('.s-hero-carousel__nav__cont'),
      slides: this.slides,
      onChange: (indx) => {
        this.goToSlide(indx)
      },
    })

    //  this._generateNavItems()
     this.setMinHeight()
    this._iniCarousel()
    this.hideProgressBar()
   


    $(window).on('resize', (_) => {
        this.setMinHeight()
    })

    $(window).on('scroll', () => {
      var scrollPos = $(document).scrollTop()
      if (scrollPos > 0) $(this.elem).addClass('anim-framed')
      else $(this.elem).removeClass('anim-framed')
    })
  }

  _iniVars() {
    this.carousel = $('.s-hero-carousel__main', this.elem)
    this.slides = $('.s-hero-carousel__slide', this.carousel)
    this.nav = $('.s-hero-carousel__nav', this.elem)
    this.navCont = $('.s-hero-carousel__nav__cont', this.elem)
  }

  _iniCarousel() {
 
    this.elem[0].style.setProperty(
      '--slide-dur',
      `${this.autoplaySpeed / 1000}s`
    )

    this.carousel.on('init', (_) => {
      setTimeout((_) => {
        this.startAutoplay()
      
        this.nav.setActiveNavItem(this.getCurrentSlide())
        // this.startIntro((_) => {

        // })
      })
    })

    this.carousel.slick({
      slide: '.s-hero-carousel__slide',
      rows: 0,
      fade: true,
      dots: false,
      arrows: false,
      infinite: true,
      edgeFriction: 0,
    })
    this.carousel.on(
      'beforeChange',
      (event, slick, currentSlide, nextSlide) => {
        this.nav.setActiveNavItem(nextSlide)
        this.setProgressBar()
      }
    )
    this.carousel.on('afterChange', (_) => {
      this.startAutoplay()
      this.setProgressBar()
      this.addTitleTransaction()
    })
  
  }

  addTitleTransaction() {
    this.carousel.find('.slick-slide').removeClass('right-to-left-enter')

    // Add the class to the current slide
    this.carousel.find('.slick-current').addClass('right-to-left-enter')
  }

  startAutoplay() {
    clearTimeout(this.autoplayTimer)

    this.autoplayTimer = setTimeout((_) => {
      this.showNextSlide()
    }, this.autoplaySpeed)
  }

  setProgressBar() {
    $('.e-progress-loader').addClass('reset')
    setTimeout(() => {
      $('.e-progress-loader').removeClass('reset')
    })
  }

  getCurrentSlide() {
    return this.carousel.slick('slickCurrentSlide')
  }

  showNextSlide() {
    const currentSlide = this.getCurrentSlide()
    const nextSlide =
      currentSlide == this.slides.length - 1 ? 0 : currentSlide + 1

    this.carousel.slick('slickGoTo', nextSlide)
  }

  goToSlide(slide) {
    this.carousel.slick('slickGoTo', slide)
  }

  hideProgressBar() {
    if (this.slides.length === 1) {
      $('.s-hero-carousel__progressBar', this.elem).addClass('hide')
    }
  }

  setMinHeight() {
    //const navContHeight = this.nav.outerHeight()
    let contHeight = 0

  //  this.elem.addClass("ready")
    const framePad = parseInt(this.elem.css("padding-top")) + parseInt(this.elem.css("padding-bottom"))
  //  this.elem.removeClass("ready")

    this.slides.each(function () {
      const slideContHeight = $(this).find(".s-hero-carousel__slide").outerHeight()
      contHeight = Math.max(contHeight, slideContHeight)
    })

    const minHeight =  contHeight 

    this.elem.css("min-height", minHeight)
  }
}

export default HeroCarousel
